import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { environment } from 'environments/environment';

@Injectable()
export class InstrumentService {

    constructor(private _http: HttpClient) {

    }

    get = (): Observable<number> => {
        return this._http.get<number>(`${environment.operation}/InstrumentSetup`);
    }

    add = (data): Observable<number> => {
        return this._http.post<number>(`${environment.operation}/InstrumentSetup`, data);
    }

    update = (data): Observable<number> => {
        return this._http.put<number>(`${environment.operation}/InstrumentSetup`, data);
    }
}
